import { useEffect, useState } from "react";
import { requestLocationPermission } from "../utils/config";
import { LocationState } from "../app/PublicPages/core/models";

export const useLocation = (): LocationState => {
    const [location, setLocation] = useState<LocationState>({
        latitude: null,
        longitude: null,
        loading: true,
        error: null,
    });

    useEffect(() => {
        const getPosition = async () => {
            try {
                const position = await requestLocationPermission();

                if (position && typeof position !== "boolean") {
                    setLocation({
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        loading: false,
                        error: null,
                    });
                } else {
                    setLocation({
                        latitude: null,
                        longitude: null,
                        loading: false,
                        error: "Location permission denied or unavailable",
                    });
                }
            } catch (err) {
                setLocation({
                    latitude: null,
                    longitude: null,
                    loading: false,
                    error: "Failed to fetch location",
                });
            }
        };

        getPosition();
    }, []);

    return location;
};